import React from "react";
import "./Contact.css";
import { AiOutlinePhone, AiOutlineMail, AiFillFolder } from "react-icons/ai";
import { motion, useViewportScroll, useTransform } from "framer-motion";
import resume from "../../img/Resume.pdf";

function Contact() {
  const { scrollYProgress } = useViewportScroll();
  const scale = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <motion.div className="c" id="contact" style={{ scale }}>
      <div
        className="c-wrapper"
        style={{
          scaleY: scrollYProgress,
        }}
      >
        <div className="title">
          <p>04. What's Next</p>
          <h1>Get In Touch </h1>
        </div>
        <div className="c-info">
          <div className="c-info-phone">
            <span>
              <AiOutlinePhone size={20} />
            </span>
            +91 7984810950
          </div>
          <div className="c-info-email">
            <span>
              {" "}
              <AiOutlineMail size={20} />
            </span>
            <a href="mailto:abhiiv5496@gmail.com?subject=Email Subject&body=Email Body">
              abhiiv5496@gmail.com
            </a>
          </div>
          <div>
            <a
              href={resume}
              download="Abhishek Vishwakarma"
              className="c-info-email"
            >
              <span>
                {" "}
                <AiFillFolder size={20} />
              </span>
              Resume{" "}
            </a>
          </div>
          <div className="c-info-brief">
            <p>
              My inbox is always open. Whether you have questions or just want
              to say Hi. <br /> I'll try my best to get back to you!
            </p>
          </div>
        </div>
        <div className="mail">
          <a href="mailto:abhiiv5496@gmail.com?subject=Email Subject&body=Email Body">
            Say Hi!{" "}
          </a>
        </div>
      </div>
    </motion.div>
  );
}

export default Contact;
